import { createContext, useContext, type Context } from 'react';

import type { TenantContextValue } from './types';

/**
 * @deprecated see https://hello.atlassian.net/wiki/spaces/agents/pages/5666612410/Deprecating+Context+hooks+in+atlassian-studio-common
 */
export const TenantContext: Context<TenantContextValue> = createContext({} as TenantContextValue);

/**
 * @deprecated see https://hello.atlassian.net/wiki/spaces/agents/pages/5666612410/Deprecating+Context+hooks+in+atlassian-studio-common
 */
export const useTenantContext = (): TenantContextValue => {
	return useContext(TenantContext);
};
